import {
	GeneratingLoaderContent,
	GeneratingLoaderOrb,
	GeneratingLoaderOrbCore,
	GeneratingLoaderOrbRing,
	GeneratingLoaderOrbWrap,
	GeneratingLoaderPhase,
	GeneratingLoaderProgressFill,
	GeneratingLoaderProgressTrack,
	GeneratingLoaderRoot,
	GeneratingLoaderSteps,
	GeneratingLoaderStep,
	GeneratingLoaderSubtitle,
	GeneratingLoaderTime,
	GeneratingLoaderTitle,
} from '../studio.styles';

const getPhaseIndex = (remainingSeconds, totalSeconds) => {
	const elapsed = Math.max(0, totalSeconds - remainingSeconds);
	const segment = totalSeconds / 3;

	if (elapsed < segment) return 0;
	if (elapsed < segment * 2) return 1;
	return 2;
};

const StudioGenerationLoader = ({
	variant = 'card',
	title,
	subtitle,
	phaseLabels = [],
	timeLabel,
	totalSeconds = 30,
	remainingSeconds = totalSeconds,
}) => {
	const progress = Math.min(
		100,
		Math.max(0, ((totalSeconds - remainingSeconds) / totalSeconds) * 100),
	);
	const activePhase = getPhaseIndex(remainingSeconds, totalSeconds);
	const currentPhaseLabel = phaseLabels[activePhase] ?? '';

	const progressDeg = progress * 3.6;

	return (
		<GeneratingLoaderRoot $variant={variant} aria-live="polite">
			<GeneratingLoaderOrbWrap $variant={variant}>
				<GeneratingLoaderOrb
					$progress={progressDeg}
					$compact={variant === 'overlay'}
					aria-hidden="true"
				>
					<GeneratingLoaderOrbRing $delay={0} $scale={1} />
					<GeneratingLoaderOrbRing $delay={-0.7} $scale={0.84} $reverse />
					<GeneratingLoaderOrbRing $delay={-1.4} $scale={0.68} />
					<GeneratingLoaderOrbCore />
				</GeneratingLoaderOrb>
			</GeneratingLoaderOrbWrap>

			<GeneratingLoaderContent $variant={variant}>
				{title ? (
					<GeneratingLoaderTitle $compact={variant === 'overlay'}>
						{title}
					</GeneratingLoaderTitle>
				) : null}
				{subtitle ? (
					<GeneratingLoaderSubtitle>{subtitle}</GeneratingLoaderSubtitle>
				) : null}
				{currentPhaseLabel ? (
					<GeneratingLoaderPhase>{currentPhaseLabel}</GeneratingLoaderPhase>
				) : null}
				{phaseLabels.length > 1 ? (
					<GeneratingLoaderSteps aria-hidden="true">
						{phaseLabels.map((label, index) => (
							<GeneratingLoaderStep
								key={label}
								$active={index === activePhase}
								$done={index < activePhase}
								title={label}
							/>
						))}
					</GeneratingLoaderSteps>
				) : null}
				{timeLabel ? (
					<GeneratingLoaderTime>{timeLabel}</GeneratingLoaderTime>
				) : null}
			</GeneratingLoaderContent>

			<GeneratingLoaderProgressTrack $variant={variant} aria-hidden="true">
				<GeneratingLoaderProgressFill style={{ width: `${progress}%` }} />
			</GeneratingLoaderProgressTrack>
		</GeneratingLoaderRoot>
	);
};

export default StudioGenerationLoader;
